import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { PasswordInput } from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { UserCircle, ShieldCheck, MapPin, Mail, KeyRound } from "lucide-react";

function Row({ icon: Icon, label, value }) {
  return (
    <div className="flex items-center gap-3 border-b border-gray-100 py-3 last:border-0">
      <Icon size={16} className="text-[#3B82F6]" />
      <span className="w-28 text-xs font-semibold uppercase tracking-wider text-gray-400">{label}</span>
      <span className="text-sm font-semibold text-gray-800">{value || "—"}</span>
    </div>
  );
}

export default function MyProfile() {
  const { user } = useAuth();
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [saving, setSaving] = useState(false);

  const change = async () => {
    if (nw.length < 6) { toast.error("Password baru minimal 6 karakter"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Password berhasil diganti");
      setCur(""); setNw("");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  const roleName = user?.role_name || (user?.role === "admin" ? "Administrator" : "Staff");

  return (
    <div className="max-w-xl">
      <h1 className="font-heading text-2xl font-bold text-[#111827] sm:text-3xl">Profil Saya</h1>
      <p className="mt-1 text-sm text-gray-500">Informasi akun Anda. Untuk mengelola akun karyawan lain, buka Master Data → User & Role.</p>

      <div className="mt-6 rounded-lg border border-gray-100 bg-white p-5 shadow-sm">
        <Row icon={UserCircle} label="Nama" value={user?.name} />
        <Row icon={ShieldCheck} label="Role" value={roleName} />
        <Row icon={MapPin} label="Location" value={user?.location} />
        <Row icon={Mail} label="Email" value={user?.email} />
      </div>

      <div className="mt-6 rounded-lg border border-gray-100 bg-white p-5 shadow-sm">
        <div className="mb-3 flex items-center gap-2"><KeyRound size={16} className="text-[#3B82F6]" /><h2 className="font-heading text-base font-semibold text-[#111827]">Ganti Password</h2></div>
        <div className="space-y-3">
          <div><Label className="text-xs">Password Saat Ini</Label><PasswordInput data-testid="profile-current-pw" value={cur} onChange={(e) => setCur(e.target.value)} className="mt-1.5" /></div>
          <div><Label className="text-xs">Password Baru (min 6)</Label><PasswordInput data-testid="profile-new-pw" value={nw} onChange={(e) => setNw(e.target.value)} className="mt-1.5" /></div>
          <Button data-testid="profile-change-pw-btn" disabled={saving} onClick={change} className="bg-[#3B82F6] font-semibold text-gray-900 hover:bg-[#C5A059]">{saving ? "Menyimpan…" : "Ganti Password"}</Button>
        </div>
      </div>
    </div>
  );
}
